import { axios, getAxiosConfig } from '../utils/apiUtils';
import React, { useState, useEffect } from 'react';
import { Redirect, useParams } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { Alert, Button, Form, Modal } from 'react-bootstrap';

import chungungoLogo from '../assets/images/logotipo-chungungo-flor.svg';
import '../main.css';
import styles from './register.module.css';
import { reportEvent } from '../utils/analyticsUtils';
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook';

/* const styles = {
  alert: {
    marginTop: '16px',
    marginBottom: '16px',
  },
  layout: {
    marginTop: '100px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  form: {
    marginLeft: 32,
    marginRight: 32,
  },
  title: {
    color: 'dark-grey'
  }
} */

const Register = () => {
  let { giftId } = useParams();
  const { t, i18n } = useTranslation();
  const sendDataToGTM = useGTMDispatch();

  const [user, setUser] = useState();
  const [name, setName] = useState();
  const [password, setPassword] = useState();
  const [passwordConfirm, setPasswordConfirm] = useState();
  const [acceptTerms, setAcceptTerms] = useState(false);

  const [showError, setShowError] = useState();
  const [showNoTerms, setShowNoTerms] = useState();

  const [goToVideoList, setGoToVideoList] = useState();
  const [showSuccess, setShowSuccess] = useState();

  const [validated, setValidated] = useState();

  const [giftData, setGiftData] = useState();

  const getGiftData = () => {
    axios.get(
      `${process.env.REACT_APP_API_URL}/payments/gifts/mercadopago/temp_user/${giftId}`,
      getAxiosConfig(),
    )
      .then((giftResponse) => {
        setGiftData(giftResponse.data);
      })
      .catch(console.error);
  }

  useEffect(
    () => {
      getGiftData();
    },
    [],
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    if (
      !user ||
      user.trim() === '' ||
      !name ||
      name.trim() === '' ||
      !password ||
      password.trim() === '' ||
      password !== passwordConfirm
    ){
      console.debug('Error!');
      setShowError(true);
      return;
    }else{
      setShowError(false);
    }

    if (
      !acceptTerms
    ){
      setShowNoTerms(true);
      return;
    }

    register();
  };

  const register = () => {
    reportEvent('03Funnel_RegisterSent', {});

    const registerData = {
      name: name,
      email: user,
      password: password,
    };

    if (giftId) {
      registerData['giftId'] = giftId;
    }

    axios.post(
      `${process.env.REACT_APP_API_URL}/auth/register`,
      registerData,
      {
        headers: { 'Content-Type': 'application/json' }
      },
    ).then((registerResponse) => {
      sendDataToGTM({event: '04Funnel_RegisterComplete', value: ''})
      reportEvent('04Funnel_RegisterComplete', {});
      setShowSuccess(true);
    }).catch(() => {
      setShowError(true);
    });
  }

  useEffect(
    () => {
      sendDataToGTM({event: '02Funnel_RegisterPageBegin', value: ''})
      reportEvent('02Funnel_RegisterPageBegin', {});
    },
    []
  );

  if (goToVideoList) {
    return (<Redirect to="/" push />);
  }

  return (
    <div className={`${styles.register}`}>

      <Modal show={showSuccess} onHide={setGoToVideoList}>
        <Modal.Header closeButton>
          <Modal.Title>{t('register.modal.title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('register.modal.message')}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={setGoToVideoList}>
            {t('register.modal.close')}
          </Button>
        </Modal.Footer>
      </Modal>

      
      <div className={`${styles.loginscreen} ${styles.login} container-fluid`}>
        <div className={`${styles.vh100} row`}>
          <div className={`col-md-6 ${styles.bgimage}`}>
            <div className="px-md-5 pt-3 col-11 mx-auto mt-md-5">
              <h2>Crea tu cuenta</h2>
              <p className={`font-weight-bold ${styles.lead}`}>
                Email, nombre y contraseña es todo lo que necesitas para conocer Chungungo.
              </p>
              <div className={`${styles.pimage}`}>
                <p>
                  Al crear tu cuenta en Chungungo tendrás acceso libre a cuentos y canciones. Si quieres acceder a otras experiencias debes suscribirte yendo a Mi Cuenta dentro de la plataforma. Que sea un feliz viaje del Chungungo!
                </p>
              </div>
            </div>
          </div>

          <div className={`col-md-6 ${styles.registerForm}`}>
            <div className="login d-flex align-items-center py-5">
              <div className="container">
                <div className="row">
                  <div className={`col-md-9 col-lg-8 mx-auto ${styles.colForm}`}>
                    <div className="p-5">

                      <div className="back mb-5">
                        <a className={`${styles.small}`} href="/#">← Volver a la página de inicio</a>
                      </div>

                      <Form>
                        {showError &&
                            <Alert
                              style={styles.alert}
                              variant="danger">
                              {t('register.alert.error')}
                            </Alert>
                          }
                          {showNoTerms &&
                            <Alert
                              style={styles.alert}
                              variant="warning">
                              Debes aceptar los términos y condiciones
                            </Alert>
                          }

                        {giftData && giftData.isUsed === false &&
                          <div class="alert alert-success" role="alert">
                            Tienes un regalo, al registrarte este se activará en tu cuenta (solo debes usar el mismo correo al que te llegó la invitación)
                          </div>
                        }
                        <div className="mb-3">
                          <label className="text-uppercase">Nombre</label>
                          <input type="text" className={`form-control ${styles.formControl}`} id="inputName" required autoFocus="" value={name} onChange={(evt) => setName(evt.target.value)} />
                        </div>

                        <div className="mb-3">
                          <label className="text-uppercase">Email</label>
                          <input type="email" className={`form-control ${styles.formControl}`} id="inputEmail" required autoFocus="" value={user} onChange={(evt) => setUser(evt.target.value)} />
                        </div>

                        <div className="mb-3">
                          <label className="text-uppercase">Contraseña</label>
                          <input type="password" className={`form-control ${styles.formControl}`} id="inputPassword" required autoFocus="" value={password} onChange={(evt) => setPassword(evt.target.value)} />
                        </div>

                        <div className="mb-3">
                          <label className="text-uppercase">Repite tu contraseña</label>
                          <input type="password" className={`form-control ${styles.formControl}`} id="inputConfirmPassword" required autoFocus=""  value={passwordConfirm} onChange={(evt) => setPasswordConfirm(evt.target.value)} />
                        </div>


                        <div className={`mb-3 form-check ${styles.formCheck}`}>
                          <Form.Group controlId="formBasicCheckbox" className="mb-3">
                            <Form.Check type="checkbox" className="form-check-input" value={acceptTerms} onChange={(event) => setAcceptTerms(event.target.checked)}/>
                            <Form.Label>Acepto los <a href="/terms_and_conditions" target="_blank">términos y condiciones</a></Form.Label>
                          </Form.Group>
                        </div>

                        <button type="submit" className="btn btn-info text-light w-100" onClick={handleSubmit}>{t('register.button.submit')}</button>

                      </Form>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Register;